import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
const baseClasses = 'inline-flex items-center justify-center border leading-[18px] font-medium';
const colorStyles = {
    ghost: '',
    gray: 'bg-secondary border-stroke-base-medium text-heading',
    white: 'bg-primary-soft border-stroke-base text-heading',
    brand: 'bg-brand-softer border-stroke-brand-subtle text-fg-brand-strong',
    danger: 'bg-danger-soft border-stroke-danger-subtle text-fg-danger-strong',
    warning: 'bg-warning-soft border-stroke-warning-subtle text-fg-warning',
    success: 'bg-success-soft border-stroke-success-subtle text-fg-success-strong',
};
const circleShapeClass = 'rounded-full';
const defaultShapeClass = 'rounded-md';
const sizeStyles = {
    sm: { base: 'text-xs px-1 py-0.5 gap-1', iconOnly: 'w-5 h-5', icon: 'w-3 h-3' },
    lg: { base: 'text-sm p-1.5 gap-1.5', iconOnly: 'w-6 h-6', icon: 'w-3.5 h-3.5' },
};
export default function Badge({ testId, label, leftIcon: LeftIcon, rightIcon: RightIcon, size = 'sm', color = 'ghost', iconOnly, circle, className, }) {
    const sizeConfig = sizeStyles[size];
    const containerSizeClass = iconOnly ? sizeConfig.iconOnly : sizeConfig.base;
    const iconClass = sizeConfig.icon;
    const colorClass = colorStyles[color];
    const shapeClass = circle ? circleShapeClass : defaultShapeClass;
    const classes = classNames(baseClasses, colorClass, containerSizeClass, shapeClass, className);
    const showLabel = Boolean(label);
    return (_jsxs("div", { className: classes, "data-testid": testId, children: [LeftIcon && _jsx(LeftIcon, { className: iconClass }), showLabel && _jsx("span", { children: label }), RightIcon && _jsx(RightIcon, { className: iconClass })] }));
}
